import {
  CustomInvoicesDocumentTypesActions,
  LOAD_INVOICES_DOCUMENT_TYPES_FAIL,
  LOAD_INVOICES_DOCUMENT_TYPES_RESET,
  LOAD_INVOICES_DOCUMENT_TYPES_SUCCESS
} from '../actions/custom-invoices-document-types.actions';
import {B2BDocumentTypeList} from '../../../invoices.model';

export const initialState: B2BDocumentTypeList = {
  b2bDocumentTypeList: []
};

export function reducerDocumentTypes(
  state = initialState,
  action: CustomInvoicesDocumentTypesActions
): B2BDocumentTypeList {
  switch (action.type) {
    case LOAD_INVOICES_DOCUMENT_TYPES_SUCCESS: {
      return action.payload ? action.payload : initialState;
    }

    case LOAD_INVOICES_DOCUMENT_TYPES_FAIL || LOAD_INVOICES_DOCUMENT_TYPES_RESET: {
      return initialState;
    }
  }

  return state;
}


